import React from 'react';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import AccountContainer from 'containers/account/AccountContainer';
import { useLocation } from 'react-router';

function Account() {
  const { pathname } = useLocation();

  return (
    <AppTemplate
      title={'Account'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <AccountContainer />
    </AppTemplate>
  );
}

export default Account;
